var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
  let { isPhone, track_value, vu_logo_path } = options;
__p+='\n<!-- Veterans United Native Ad -->\n<div class="mrtg-rate-card ad_outer">\n  <div class="row offer">\n    <div class="col-sm-3 col-xs-6 col-xxs-6 vu-content">\n      <img src="'+
((__t=( vu_logo_path ))==null?'':__t)+
'" class=\'lender-logo display-block\'/>\n      <div class="nmls margin-right-sm">NMLS &num;1907</div>\n      <a href="https://pubads.g.doubleclick.net/gampad/clk?id=4898887620&iu=/8058/CLICK/VU/MORT_RATE_TABLE_LINK" class="margin-bottom-sm" target="_blank" rel=\'nofollow\'>\n        More Details\n      </a>\n    </div>\n    <div class="col-sm-6 col-xs-6 col-xxs-6 vu-content vu-content-text">\n      <p class="vu-native-ad-message">\n        Veterans: See if you qualify for a lower <br/>rate with a $0 down VA Home Loan\n      </p>\n    </div>\n    <div class="col-sm-3 col-xs-12 col-xxs-12 content-container">\n      <a href="https://pubads.g.doubleclick.net/gampad/clk?id=4898887401&iu=/8058/CLICK/VU/MORT_RATE_TABLE_BUTTON" class="btn vu-btn btn-primary margin-bottom" target="_blank" rel=\'nofollow\'>\n        Check Eligibility\n      </a>\n      <div class="lender-phone text-align-center">\n        ';
if (isPhone) {
__p+='\n          <a href="tel:(844) 488-8229" data-omtag="'+
((__t=(track_value))==null?'':__t)+
'" class="phone" data-phone-number="(844) 488-8229"><i class="ra ra-phone"></i>(844) 488-8229</a>\n        ';
} else {
__p+='\n          <div class="phone">(844) 488-8229</div>\n        ';
 } 
__p+='\n        <span>Toll Free</span>\n      </div>\n    </div>\n  </div>\n</div>\n<!-- End Veterans United Native Ad -->\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/vu_native_ad.jst.ejs